<template>
    <div>
        <div class="info-box">
            <div class="info-title">
                <h3>基本信息</h3>
                <p></p>
            </div> 
            <div class="info-main">
                <div class="input-box">
                    <p>申请人工号：</p>
                    <a-input class="input" :value='info.teacherId' disabled></a-input>
                </div>
                <div class="input-box">
                    <p>申请人姓名：</p>
                    <a-input class="input" :value='info.teacherName' disabled></a-input>
                </div>
                <div class="input-box">
                    <p>申请部门：</p>
                    <a-input class="input" :value='info.orgName' disabled></a-input>
                </div>
                <div class="input-box">
                    <p>联系电话：</p>
                    <a-input class="input" :value='info.mobile'  disabled></a-input>
                </div>
                <div class="input-box">
                    <p>电子邮箱：</p>
                    <a-input class="input" :value='info.email' disabled></a-input>
                </div>
            </div>
        </div>
        <div class="info-box">
            <div class="info-title">
                <h3>申请信息</h3>
                <p></p>
            </div>
            <div class="info-main">
                <div class="input-maxbox">
                    <p>主送单位：</p>
                    <a-input class="textarea" v-model="info.mainOrg"></a-input>
                </div>
                <div class="input-maxbox">
                    <p>用印详情：</p>
                    <div class="textarea">
                        <a-select class="yylx" v-model="info.type" placeholder='用印类型' @change="reviewerChange(info.type)">
                            <a-select-option value="党章">
                                党章
                            </a-select-option>
                            <a-select-option value="行政公章">
                                行政公章
                            </a-select-option>
                        </a-select>
                        <a-input-number class="clfs" v-model="info.materialNumber" placeholder="材料份数" :min="1" :max="100" />
                        <a-input class="yysy" v-model="info.targetUse" placeholder="用印事由"></a-input>
                    </div>
                </div>
                <div class="upload-info-box">
                    <p class="p">附件上传：</p>
                    <div class="upload-box">
                        <a-upload-dragger
                            name="file"
                            class="upload-dragger"
                            list-type="picture-card"
                            :multiple="true"
                            :action="$store.state.axiosUrl+'/api-f/files'"
                            :headers="headers"
                            @change="fileChange"
                            :file-list="fileList"
                            :disabled="type=='look'"
                        >
                            <p class="ant-upload-drag-icon">
                                <a-icon type="inbox" />
                            </p>
                            <p class="ant-upload-text">点击或拖拽附件上传</p>
                        </a-upload-dragger>
                    </div>
                </div>
                <div class="input-maxbox">
                    <p>备注：</p>
                    <a-input v-model="info.remark" class="textarea"></a-input>
                </div>
                <div class="input-box">
                    <p>审核人：</p>
                    <a-select
                        class="input"
                        v-model="info.approverCode"
                        @change="handleChange"
                        >
                        <a-select-option v-for="(item,index) in reviewerArr" :key="index" :value="item.dataCode" :label="item.dataName">{{item.dataName}}</a-select-option>
                    </a-select>
                </div>
            </div>
        </div>
        <div class="info-box" v-if="type=='approve' || type=='look'">
            <div class="info-title">
                <h3>审批意见</h3>
                <p></p>
            </div>
            <div class="info-main">
                <div class="input-box input-box-center">
                    <p>意见：</p>
                    <a-textarea class="input" v-model="approve.approveComments" :rows="2" :disabled="type!='approve'"/>
                </div>
            </div>
        </div>
        <div class="btn-box" v-if="type !='approve'">
            <a-button type="primary" v-if="type=='edit'||type=='add'" @click="sub('commit')">提交</a-button>
            <a-button type="primary" v-if="type=='edit'||type=='add'" @click="sub('draft')">暂存</a-button>
            <a-button @click="$router.go(-1)">取消</a-button>
        </div>
        <div class="btn-box" v-if="type=='approve'">
            <a-button type="primary"  @click="approveClick('approved')">同意</a-button>
            <a-button type="primary"  @click="approveClick('reject')">驳回</a-button>
            <a-button @click="$router.go(-1)">取消</a-button>
        </div>
    </div>
</template>
<script>
    import { getDicts } from '@/baseAPI/dictionary'
    import { add,update,info,approve } from '@/baseAPI/undergraduate/culture/seal'
    export default {
        name: '',
        data () {
            return {
                headers:{
                    'Authorization':'Bearer '+ this.$store.state.access_token
                },
                type:'',
                info:{
                    approvalStatus: "",
                    orgCode: "",
                    orgName: "",
                    teacherId: "",
                    teacherName: "",
                    telPhone: "",
                    email: "",
                    mainOrg: "",
                    materialNumber: null,
                    remark: "",
                    targetUse:"",
                    files: [],
                    approverCode:"",
                    approverName:""
                },
                fileList:[],
                user:null,
                files: [],
                approve:{
                    id:'',
                    approvalStatus:'',
                    approveComments:''
                },
                reviewerArr:[]
            }
        },
        mounted () {
            this.user=this.$store.state.user;
            this.info.orgCode=this.user.orgCode;
            this.info.orgName=this.user.orgName;
            this.info.teacherId=this.user.userId;
            this.info.teacherName=this.user.name;
            this.info.email=this.user.email;
            this.info.telPhone=this.user.phone;
            this.type=this.$route.query.type;
            this.approve.id=this.$route.query.id;

            if(this.type!='add'){
                setTimeout(()=>{
                    info(this.$route.query.id).then(res=>{
                        this.info=res.data;
                        this.approve.approveComments=this.info.approveComments
                        this.fileList=[];
                        if(res.data.files!=''&&res.data.files!=null){
                            for(let i=0;i<res.data.files.length;i++){
                                this.fileList.push({
                                    uid: i,
                                    name: res.data.files[i].fileName,
                                    status: 'done',
                                    url: this.$store.state.axiosUrl+res.data.files[i].fileUrl,
                                })
                                this.files.push({'fileName':res.data.files[i].fileName,'fileUrl':res.data.files[i].fileUrl})
                            }
                        }
                        this.reviewerChange(this.info.type)
                    })
                },100)
            }

        },
        methods:{
            handleChange(value){
                this.info.approverCode=value
                this.reviewerArr.forEach(e=>{
                    if(e.dataCode == value){
                        this.info.approverName=e.dataName
                    }
                })
                console.log(this.info)
            },
            reviewerChange(type){
                if(type == "党章"){
                    getDicts({dataCode:'DZYYSQSHR',status:true}).then(res=>{
                        this.reviewerArr=res.data.dicts;
                    })
                }else if(type == "行政公章"){
                    getDicts({dataCode:'XZGZYYSQSHR',status:true}).then(res=>{
                        this.reviewerArr=res.data.dicts;
                    })
                }
            },
            fileChange(file){
                if(typeof file.file.response!='undefined'){
                    var res=file.file.response;
                    this.$notification['success']({
                        message: '成功',
                        description:'文件上传成功'
                    });
                    this.files.push({'fileName':res.name,'fileUrl':res.url})
                }else if(file.file.status=='removed'){
                    var num=this.file.indexOf(file.file);
                    this.files.splice(num, 1)
                }
                this.fileList=file.fileList;
                console.log("fileList",this.fileList)
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            approveClick(state){
                this.approve.approvalStatus=state
                approve(this.approve).then(res=>{
                    if(res.data.success){
                        this.$notification['success']({
                            message: '成功',
                            description:'用印申请'+(state=='approved'?'审批通过':'驳回成功'),
                        });
                        this.$router.go(-1)
                    }else{
                        this.$notification['error']({
                            message: '失败',
                            description:res.data.errorMessage,
                        });
                    }
                })

            },
            sub(state){
                var isSub=true;
                // var arr=['kcbId']
                // for(let i=0;i<arr.length;i++){
                //     if(this.info[arr[i]]==null||this.info[arr[i]]===''){
                //         isSub=false;
                //         break;
                //     }
                // }
                if(isSub){
                    this.info.approvalStatus = state
                    this.info.files=this.files
                    if(this.type=='add'){
                        add(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description: state == 'commit' ? '新增用印申请成功，请联系印章管理人员审批！':'保存用印申请草稿成功！',
                                    duration: state == 'commit' ? 0 : 5,
                                });
                                this.$router.go(-1)
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }else{
                        update(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'修改用印申请成功',
                                });
                                this.$router.go(-1)
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }
                }else{
                    this.$notification['warning']({
                        message: '警告',
                        description:'请填写完整！',
                    });
                }
            }
        }
    }
</script>
<style scoped>
    .info-box{
        margin-bottom: 2rem;
    }
    .info-title{
        position: relative;
        line-height: 3rem;
    }
    .info-title h3{
        font-size: 1.2rem;
        font-weight: bold;
        letter-spacing: 2px;
        padding-left: 10px;
        color: #245086;
    }
    .info-title p{
        position: absolute;
        left: 0;
        bottom: 0;
        width: 50%;
        height: 3px;
        background-image: linear-gradient(to right, #245086 , rgba(36,80,134,0));
    }
    .info-title .ant-btn{
        float: right;
        margin-top: calc(1.5rem - 16px);
        margin-right: 2rem;
    }
    .info-main{
        display: flex;
        flex-wrap: wrap;
        margin-top: 1.5rem;
    }
    .info-main .input-box{
        width: 33%;
        display: flex;
        line-height: 32px;
        margin-bottom: 1.5rem;
        position: relative;
    }
    .info-main .input-box-center{
        width: 66%;
    }
    .info-main .input-box p{
        width: 10rem;
        text-align: right;
    }
    .info-main .input-box .input{
        width: calc(100% - 10rem);
    }
    .info-main .input-box .radio{
        width: calc(100% - 10rem);
    }
    .info-main .input-box .tips{
        width: calc(100% - 11rem);
        position: absolute;
        right: 0;
        top: 100%;
        font-size: 13px;
        line-height: 20px;
        color: #1890ff;
    }
    .ant-table-wrapper{
        margin-top: 2rem;
    }
    .ant-table-wrapper >>> .ant-empty-normal{
        display: none;
    }
    .text-box{
        display: flex;
        margin-bottom: 0.5rem;
    }
    .text-box p{
        font-size: 1rem;
        line-height: 2rem;
    }
    .text-box .title{
        width: 5rem;
        text-align: right;
    }
    .text-box .text{
        border: 1px solid #ccc;
        padding: 0 10px;
        border-radius: 5px;
    }
    .action-btn{
        color: #40a9ff;
        display: inline-block;
    }
    .ant-table-wrapper >>> .ant-table-thead > tr > th,
    .ant-table-wrapper >>> .ant-table-tbody > tr > td{
        padding: 10px;
    }
    .ant-table-wrapper .input-box{
        width: 100%;
    }
    .btn-box{
        text-align: center;
    }
    .btn-box .ant-btn{
        margin: 0 1rem;
    }
    .input >>> .ant-input[disabled],
    .ant-input[disabled],.ant-select-disabled,.ant-input-number-disabled{
        color: rgba(0, 0, 0, 0.65);
        background-color: transparent;
    }
    .ant-select-disabled >>> .ant-select-selection{
        background-color: transparent;
    }
    .standard{
        width: 28px;
        height: 100px;
        position: absolute;
        right: 0;
        top: 200px;
        text-align: center;
        border-radius: 6px 0 0 6px !important;
        z-index: 0;
        pointer-events: auto;
        cursor: pointer;
        color: rgb(255, 255, 255);
        background-color: #245086;
        opacity: 0.8;
        padding: 2px 0px 0px 0px;
    }

    .standard:hover{
        opacity: 1;
    }

    .info-main .input-maxbox{
        width: 99%;
        display: flex;
        line-height: 32px;
        position: relative;
        margin-bottom: 1.5rem;
    }

    .info-main .input-maxbox p{
        width: 10rem;
        text-align: right;
    }

    .info-main .input-maxbox .textarea{
        width: calc(100% - 10rem);
    }

    .info-main .input-maxbox .textarea .yylx{
        width: 20%;
    }

    .info-main .input-maxbox .textarea .clfs{
        margin-left: 1rem;
        width: calc(20% - 1rem);
    }

    .info-main .input-maxbox .textarea .yysy{
        margin-left: 1rem;
        width: calc(60% - 1rem);
    }

    .info-main .input-notes{
        width: 99%;
        display: flex;
        line-height: 32px;
        position: relative;
    }

    .info-main .input-notes .notes{
        width: calc(100% - 10rem);
        text-align: left;
        font-size: 0.9rem;
    }

    .info-main .input-notes .note-title{
        width: 10rem;
        text-align: right;
        font-size: 0.9rem;
        font-weight: bolder;
        color: black;
    }

    .info-main .upload-info-box{
        width: 99%;
        margin-bottom: 1.5rem;
    }

    .info-main .upload-info-box .p{
        width: 10rem;
        text-align: right;
    }

    .upload-info-box{
        margin-bottom: 2rem;
        display: flex;
    }

    .upload-box{
        width:calc(100%-10rem);
        height: 100%;
        display: flex;
    }

    .upload-dragger{
        display: flex;
    }

    .upload-box >>> .ant-upload-list:after{
      content: ".";
      display: block;
      font-size: 0;
      height: 0;
      clear: both;
    }
    .upload-box >>> .ant-upload.ant-upload-disabled{
        display: none;
    }

</style>
